module.exports = __webpack_public_path__ + "img/MapUs.21d03b32.png";